import React from "react";
import { api } from "@/lib/api";

const reported = new Set();
const report = (error, info) => {
  const message = `${error?.name || "Error"}: ${error?.message || error}`.slice(0, 2000);
  if (reported.has(message)) return;
  reported.add(message);
  const stack = `${error?.stack || ""}\n--- component ---${info?.componentStack || ""}`.slice(0, 8000);
  api.post("/errors/report", { message, stack, path: window.location.pathname }).catch(() => {});
};

const isChunkError = (e) => /ChunkLoadError|Loading chunk|Failed to fetch dynamically imported module/i.test(`${e?.name} ${e?.message}`);

export class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("UI error:", error);
    report(error, info);
    if (isChunkError(error) && !sessionStorage.getItem("minit_chunk_reload")) {
      sessionStorage.setItem("minit_chunk_reload", "1");
      window.location.reload();
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    if (this.props.silent) return null;
    return (
      <div className="grid min-h-screen place-items-center bg-slate-50 p-6 text-center" data-testid="error-boundary">
        <div className="max-w-md">
          <h1 className="text-2xl font-bold text-violet-700">MinitAI</h1>
          <p className="mt-3 text-slate-700">Maaf, berlaku ralat semasa memaparkan halaman ini. / Sorry, something went wrong.</p>
          <button onClick={() => window.location.reload()} className="mt-6 rounded-xl bg-violet-600 px-5 py-2.5 font-semibold text-white hover:bg-violet-700" data-testid="error-boundary-reload">
            Muat semula / Reload
          </button>
        </div>
      </div>
    );
  }
}
